module.exports = __webpack_public_path__ + "static/media/generic_file.f9988671.svg";